module.exports = __webpack_public_path__ + "background-c6ef2f49d64d5cdc507cf2f712a5a038.png";